import { Box, Tab, Tabs } from "@mui/material";
import { SwayyProductDetailTab } from "../../../models/products/SwayyProductDetail";
import { swayyColors, swayyFont, swayyRadii } from "../../../theme/tokens";

const TABS: Array<{ id: SwayyProductDetailTab; label: string }> = [
  { id: "info", label: "Info" },
  { id: "variants", label: "Variants" },
  { id: "images", label: "Images" },
  { id: "seo", label: "SEO" },
];

interface SwayyProductTabsProps {
  activeTab: SwayyProductDetailTab;
  onChange: (tab: SwayyProductDetailTab) => void;
}

const SwayyProductTabs = ({ activeTab, onChange }: SwayyProductTabsProps) => {
  const activeIndex = Math.max(
    0,
    TABS.findIndex((tab) => tab.id === activeTab),
  );

  return (
    <Box
      sx={{
        borderBottom: "none",
        mb: 0,
      }}
    >
      <Tabs
        value={activeIndex}
        onChange={(_event, index: number) => {
          const next = TABS[index];
          if (next) onChange(next.id);
        }}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          minHeight: 44,
          mb: 0,
          "& .MuiTabs-indicator": {
            height: 3,
            borderRadius: "3px 3px 0 0",
            backgroundColor: swayyColors.pine,
          },
          "& .MuiTab-root": {
            minHeight: 44,
            px: 2,
            textTransform: "none",
            fontFamily: swayyFont,
            fontWeight: 600,
            fontSize: 14,
            color: swayyColors.textSecondary,
            borderRadius: `${swayyRadii.sm} ${swayyRadii.sm} 0 0`,
          },
          "& .Mui-selected": {
            color: `${swayyColors.deepGreen} !important`,
          },
        }}
      >
        {TABS.map((tab) => (
          <Tab key={tab.id} label={tab.label} disableRipple />
        ))}
      </Tabs>
    </Box>
  );
};

export default SwayyProductTabs;
